export default "__VITE_ASSET__COZ5kAAg__"